<template>
    <div class="date-select">
        <a href="javascript:void(0)" class="dates custom-select bg-transparent" @click="showPanel = !showPanel">{{value? smallDateFormatter(value) : 'GG/MM/YYYY'}}</a>
        <div @click="showPanel = false" v-if="showPanel" class="position-absolute p-1 border rounded bg-white" style="z-index: 10; width: 225px; max-height: 130px; overflow: auto;">
            <button v-for="(item, index) in dates" :key="index" style="width: 45px" class="rounded-0 m-1 px-1 btn btn-outline-primary btn-sm nowrap" @click="onSelect(item)">
                {{smallerDateFormatter(item)}}
            </button>
        </div>
    </div>
</template>

<script>
import {smallDateFormatter, smallerDateFormatter} from '../../../utils/formatter'

export default {
  name: 'DateSelect',
  props: {
    dates: {
      type: Array,
      default: () => []
    },
    value: {
      type: Date,
      default: new Date()
    }
  },
  data () {
    return {
      showPanel: false
    }
  },
  methods: {
    smallDateFormatter,
    smallerDateFormatter,
    onSelect (date) {
      this.$emit('input', date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/DateSelect.vue